import React, { useState } from "react";
import { useStore } from "../../../helpers/helpers";
import { useTranslation } from "react-i18next";
import { clone, values } from "lodash";
import { Button, ListItem } from "@mui/material";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export const ServiceFilteredBy = () => {
    const rootStore = useStore();
    const { serviceRequestsStore } = rootStore;
    const { activeServiceFilter } = serviceRequestsStore;
    const { t } = useTranslation("manage_voters");
    const result = removeEmptyValues(activeServiceFilter);
    const clone_service_filters = clone(activeServiceFilter);

    const handleClearFilter = (key, valueToRemove) => {
        const updatedFilters = { ...clone_service_filters };
        // const keyComparisonMapping = {
        //     assignee: "assignee.name",
        //     status: "status.status",
        //     location: "location.location",
        //     type: "type.name",
        //     nodes: "name",
        // };
        const keyComparisonMapping = {
            assignee: "assignee.name",
            status: "status.status",
            priority: "priority.name",
            location: "location.location",
            type: "type.name",
            created_by: "name",
            constituency: "name",
            nodes: "name",
        };

        if (!updatedFilters[key]) return;
        if (Array.isArray(updatedFilters[key])) {
            const comparisonProperty = keyComparisonMapping[key];
            updatedFilters[key] = updatedFilters[key].filter((item) => {
                if (comparisonProperty) {
                    return (
                        getNestedValue(item, comparisonProperty) !==
                        valueToRemove
                    );
                }
                return item !== valueToRemove;
            });
        }
        serviceRequestsStore.updateServiceFilter(updatedFilters);
    };

    const getNestedValue = (obj, path) => {
        return path.split(".").reduce((acc, part) => acc && acc[part], obj);
    };

    return (
        <>
            <div className="bg-white rounded-xl shadow-sm p-4 mb-4 border border-gray-200">
                <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-medium text-gray-700 mr-2">
                        {t("Filtered By :")}
                    </span>

                    {/* Filter Chips */}
                    <div className="flex flex-wrap gap-2 flex-1 overflow-x-auto">
                        {result.map(({ key, value }) => (
                            <div key={key} className="flex flex-wrap gap-2">
                                {Array.isArray(value) ? (
                                    value.map((item, index) => (
                                        <Chip
                                            key={`${key}-${index}`}
                                            label={
                                                key === "nodes"
                                                    ? item
                                                    : `${key}: ${item}`
                                            }
                                            onDelete={() =>
                                                handleClearFilter(key, item)
                                            }
                                            size="small"
                                            sx={{
                                                backgroundColor: "#EFF6FF",
                                                color: "#1E40AF",
                                                fontWeight: 500,
                                                "& .MuiChip-deleteIcon": {
                                                    color: "#3B82F6",
                                                    "&:hover": {
                                                        color: "#1E40AF",
                                                    },
                                                },
                                            }}
                                        />
                                    ))
                                ) : (
                                    <Chip
                                        label={
                                            key === "nodes"
                                                ? value
                                                : `${key}: ${value}`
                                        }
                                        onDelete={() =>
                                            handleClearFilter(key, value)
                                        }
                                        size="small"
                                        sx={{
                                            backgroundColor: "#EFF6FF",
                                            color: "#1E40AF",
                                            fontWeight: 500,
                                            "& .MuiChip-deleteIcon": {
                                                color: "#3B82F6",
                                                "&:hover": {
                                                    color: "#1E40AF",
                                                },
                                            },
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                    </div>

                    <Button
                        variant="text"
                        color="error"
                        size="small"
                        startIcon={<CloseOutlinedIcon fontSize="small" />}
                        onClick={async () => {
                            await serviceRequestsStore.updateServiceFilter({});
                        }}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            minWidth: "auto",
                        }}
                    >
                        {t("Clear Filters")}
                    </Button>
                </div>
            </div>
        </>
    );
};
// const removeEmptyValues = (obj) => {
//   let result = [];
//
//   Object.entries(obj).forEach(([key, value]) => {
//     if (Array.isArray(value) && value.length > 0) {
//       let extractedValues;
//
//       switch (key) {
//         case "assignee":
//           extractedValues = value
//             .map((item) => item?.assignee?.name)
//             .filter((name) => name);
//           break;
//         case "status":
//           extractedValues = value
//             .map((item) => item?.status?.status)
//             .filter((status) => status);
//           break;
//         case "location":
//           extractedValues = value
//             .map((item) => item?.location?.location)
//             .filter((location) => location);
//           break;
//         case "type":
//           extractedValues = value
//             .map((item) => item?.type?.name)
//             .filter((name) => name);
//           break;
//
//         case "nodes":
//           extractedValues = value.map((item) => item?.name);
//
//           break;
//         default:
//           return;
//       }
//
//       if (extractedValues.length > 0) {
//         result.push({ key, value: extractedValues });
//       }
//     }
//   });

const removeEmptyValues = (obj) => {
    let result = [];

    Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
            let extractedValues;

            switch (key) {
                case "assignee":
                    extractedValues = value
                        .map((v) => v?.assignee?.name)
                        .filter(Boolean);
                    break;

                case "status":
                    extractedValues = value
                        .map((v) => v?.status?.status)
                        .filter(Boolean);
                    break;

                case "priority":
                    extractedValues = value
                        .map((v) => v?.priority?.name)
                        .filter(Boolean);
                    break;

                case "location":
                    extractedValues = value
                        .map((v) => v?.location?.location)
                        .filter(Boolean);
                    break;

                case "type":
                    extractedValues = value
                        .map((v) => v?.type?.name)
                        .filter(Boolean);
                    break;

                case "created_by":
                    extractedValues = value.map((v) => v?.name).filter(Boolean);
                    break;

                case "constituency":
                    extractedValues = value.map((v) => v?.name).filter(Boolean);
                    break;

                case "nodes":
                    extractedValues = value.map((v) => v?.name).filter(Boolean);
                    break;

                default:
                    return;
            }

            if (extractedValues.length > 0) {
                result.push({ key, value: extractedValues });
            }
        }
    });

    return result;
};
